import Datepicker from './Datepicker.vue';

export default Datepicker;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/form/components/datepicker/index.ts